<template>
  <div class="version-container">
    <div class="title">
      <img class="title_img"
           src="../../assets/images/07/banben_icon.png"
           alt="">
      用户列表
    </div>
    <el-form ref="form"
             class="version_search"
             :inline="true">
      <el-form-item label="所属应用">
        <el-select v-model="appName"
                   size="small">
          <el-option v-for="item in appNameOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本更新方式">
        <el-select v-model="status"
                   size="small">
          <el-option v-for="item of statusOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="版本号">
        <el-input v-model="versionNumber"
                  size="small"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item class="btn_box">
        <el-button type="primary"
                   size="small"
                   class="search_btn"
                   @click="handleSearchClick">查看</el-button>
        <router-link to="version/addVersion">
          <el-button type="warning"
                     size="small"
                     class="add_btn">添加</el-button>
        </router-link>
      </el-form-item>
    </el-form>
    <div class="version_table">
      <el-table :data="versionData.result"
                style="width: 100%"
                height="100%">
        <el-table-column class-name="number"
                         fixed
                         label=""
                         align="center"
                         type="index"
                         width="1">
        </el-table-column>
        <el-table-column prop="appUrl"
                         header-align="center"
                         align="left"
                         min-width="110"
                         label="更新路径">
        </el-table-column>
        <el-table-column prop="appName"
                         header-align="center"
                         align="center"
                         label="应用名称"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="version"
                         label="版本号"
                         header-align="center"
                         align="center"
                         min-width="70">
        </el-table-column>
        <el-table-column label="移动设备"
                         header-align="center"
                         align="center"
                         min-width="94">
          <template slot-scope="scope">
            <div v-if="scope.row.mobileType === 0">iOS</div>
            <div v-else-if="scope.row.mobileType === 1">安卓</div>
            <div v-if="scope.row.mobileType === 2">智能硬件</div>
            <div v-if="scope.row.mobileType === 3">智能硬件手机</div>
          </template>
        </el-table-column>
        <el-table-column label="更新方式"
                         header-align="center"
                         align="center"
                         min-width="69">
          <template slot-scope="scope">
            <div v-if="scope.row.updateStatus === 0">强制更新</div>
            <div v-else-if="scope.row.updateStatus === 1">选择更新</div>
          </template>
        </el-table-column>
        <el-table-column header-align="center"
                         prop="createDate"
                         label="添加时间"
                         width="92"
                         align="left">
        </el-table-column>
        <el-table-column header-align="center"
                         label="数据状态"
                         min-width="82"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status===0">可用</div>
            <div v-else-if="scope.row.status===1">禁用</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="备注"
          prop="remarks"
          header-align="center"
          align="center"
          min-width="100"
        ></el-table-column> -->
        <el-table-column label="操作"
                         class="operation"
                         header-align="center"
                         align="center"
                         width="175">
          <template slot-scope="scope">
            <el-tooltip class="item update"
                        effect="dark"
                        content="修改"
                        placement="top">
              <el-button @click="handleUpdateClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="禁用"
                        placement="top"
                        v-if="scope.row.status === 0">
              <el-button @click="handleDisabledClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item unblocked"
                        effect="dark"
                        content="解禁"
                        placement="top"
                        v-else-if="scope.row.status === 1">
              <el-button @click="handleDisabledClick(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item delete"
                        effect="dark"
                        content="删除"
                        placement="top">
              <el-button @click="handleDeleteClick(scope.row.id)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pages">
      <span class="demonstartion"> 共{{versionData.total}}条记录</span>
      <el-pagination :page-size="versionData.pageSize"
                     layout="prev, pager, next"
                     :total="versionData.total"
                     background
                     @current-change="handleCurrentChange">
      </el-pagination>

    </div>
  </div>
</template>

<script>
import { versionList, deleteVersion, disableVersion } from 'apis/index'

export default {
  name: 'Container',
  data () {
    return {
      versionData: [],

      appName: '',
      appNameOptions: [{
        value: '0',
        label: 'V货帮-货主端'
      }, {
        value: '1',
        label: 'V货帮-物流端'
      }, {
        value: '2',
        label: 'V货帮-车载终端-硬件'
      }, {
        value: '3',
        label: 'V货帮-车载终端-手机'
      }],
      status: '',
      statusOptions: [{
        value: '0',
        label: '强制更新'
      }, {
        value: '1',
        label: '选择更新'
      }],
      versionNumber: '',
      pageNum: 1

    }
  },
  mounted () {
    this.getVersionData()
  },
  methods: {
    getVersionData () { // 获取版本管理列表
      console.log(this.appName, this.status, this.versionNumber)
      versionList({
        pageNum: this.pageNum,
        appType: this.appName,
        updateStatus: this.status,
        version: this.versionNumber
      }).then(res => {
        if (res.data.code === 200) {
          this.versionData = res.data.data
        } else if (res.data.code === 210) {
          this.versionData = []
        }
      })
    },
    handleCurrentChange (val) { // 分页
      this.pageNum = val
      this.getVersionData()
    },

    handleUpdateClick (id) { // 修改version
      this.$router.push({
        path: 'version/addVersion',
        query: {
          item: id
        }
      })
    },
    handleSearchClick () { // 查询version
      this.getVersionData()
      // const appType = this.appName ? this.appName : ''
      // const updateStatus = this.status ? this.status : ''
      // const version = this.versionNumber
      // versionList({
      //   appType,
      //   updateStatus,
      //   version
      // }).then(res => {
      //   if (res.data.code === 200) {
      //     this.versionData = res.data.data
      //   } else if (res.data.code === 210) {
      //     this.versionData = []
      //   }
      // })
    },
    handleDisabledClick (id) { // 禁用及解禁version
      disableVersion({ id }).then(res => {
        if (res.data.code === 200) {
          this.getVersionData()
        }
      })
    },
    handleDeleteClick (id) { // 删除version
      deleteVersion({ id: id }).then(res => {
        if (res.data.code === 200) {
          for (var i = 0; i < this.versionData.result.length; i++) { // 从当前列别表中删除该数据
            if (this.versionData.result[i].id === id) {
              this.versionData.result.splice(i, 1)
            }
          }
        }
      })
    }
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.version-container
  padding 20px
  height 100%
  min-width 944px
  .title
    width 100%
    height 46px
    line-height 46px
    color #212832
    background #fff
    border-bottom 1px solid #cfd5dc
    .title_img
      margin 0 8px 0 14px
  .version_search
    width 100%
    background #fff
    position relative
    .el-form-item
      margin-bottom 5px
      margin-left 15px
    .btn_box
      // width 170px
      float right
      position absolute
      top 0
      right 0
      .search_btn
        searchBtn()
      .add_btn
        margin-left 20px
        addBtn()
    .el-input
      // margin-left 10px
      width 150px
  .version_table
    height calc(100% - 170px)
  .el-table
    background #f7f9fb
    th
      background #e7f0f8
      .cell
        height 25px
        line-height 25px
    td
      .cell
        size12()
        .el-button
          padding 6px 14px
          width 28px
          cursor pointer
          height 28px
          margin 0 8px
          &.update
            update()
          &.unblocked
            unblocked()
          &.delete
            delete()
.el-popover
  max-width 166px
  background #e6f3fe
  border 1px solid #cfd5dc
  border-radius 1px
  size12()
.el-pagination
  color #5e656f
  font-weight 100
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
  background transparent
  border 1px solid #cfd5dc
.pages
  margin-top 15px
  .demonstartion
    float right
    line-height 45px
    color #5e656f
</style>
